import {
    Button,
    createStyles,
    makeStyles,
    Theme,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    createTheme,
    ThemeProvider,
} from "@material-ui/core";
import styles from "./OnLeaveDialog.module.css";
import React from "react";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import { t } from "i18next";

interface OnLeaveDialogProps {
    openDialog: boolean;
    dialogTitle: string;
    dialogContent: string;
    dialogActions: string;
    handleCloseDialog: () => void;
    handleCancel: () => void;
    handleConfirm: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            "& .MuiDialog-paperScrollPaper": {
                backgroundColor: "#202327",
                width: IsDevice("iphone") ? "350px" : "560px",
                height: IsDevice("iphone") ? "240px" : "216px",
                alignItems: "center",
            },
        },
        dialogTitle: {
            "& .MuiTypography-h6": {
                fontSize: "18px",
                fontFamily: "noto-sans-cjk-jp",
                color: "white",
            },
            padding: "40px 24px 2px 10px",
        },
        dialogContent: {
            "& .MuiDialogContentText-root": {
                fontFamily: "noto-sans-cjk-jp",
                color: "var(--gray-80)",
                textAlign: "center",
            },
            marginLeft: "15px",
        },
        dialogActions: {
            marginTop: "-5px",
            marginBottom: "40px",
            justifyContent: "center",
        },
    })
);

const theme = createTheme({
    palette: {
        secondary: {
            main: "#16ADC1",
        },
    },
});

function OnLeaveDialog({
    openDialog,
    dialogTitle,
    dialogContent,
    dialogActions,
    handleCloseDialog,
    handleCancel,
    handleConfirm,
}: OnLeaveDialogProps) {
    const classes = useStyles();

    return (
        <Dialog
            disableEscapeKeyDown
            fullWidth={false}
            maxWidth="md"
            open={openDialog}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    handleCloseDialog();
                }
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={classes.root}
        >
            <div className={styles.dialogTitle}>
                <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">
                    {dialogTitle}
                </DialogTitle>
            </div>
            <DialogContent className={classes.dialogContent}>
                <DialogContentText id="alert-dialog-description">{dialogContent}</DialogContentText>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <ThemeProvider theme={theme}>
                    <Button
                        size="medium"
                        variant="outlined"
                        type="submit"
                        color="secondary"
                        style={{
                            border: "solid 2px #5D5D5D",
                            color: "#9C9C9C",
                            marginRight: "8px",
                            fontFamily: "noto-sans-cjk-jp",
                            width: IsDevice("iphone") ? "120px" : "200px",
                        }}
                        className={styles.button}
                        onClick={handleCancel}
                    >
                        {t("キャンセル")}
                    </Button>
                </ThemeProvider>
                <Button
                    size="medium"
                    variant="contained"
                    type="submit"
                    color="secondary"
                    style={{
                        fontFamily: "noto-sans-cjk-jp",
                        color: "var(--white)",
                        width: IsDevice("iphone") ? "120px" : "200px",
                    }}
                    onClick={handleConfirm}
                    autoFocus
                    className={styles.button}
                >
                    {dialogActions}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default OnLeaveDialog;
